module.exports = __webpack_public_path__ + "static/media/pick3-logo.6dfdf05a.png";